var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTransferi = function SvgTransferi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#454B56",
    fillRule: "evenodd",
    d: "M16.971 17.033H5.26a.7.7 0 0 1 0-1.4h11.852l-3.209-3.111a.7.7 0 0 1 .975-1.005l4.378 4.246a.7.7 0 0 1 .114.861.7.7 0 0 1-.297.321l-4.336 4.205a.7.7 0 1 1-.974-1.005zM4.63 7.958a.7.7 0 0 1 .113-.862L9.121 2.85a.7.7 0 0 1 .975 1.006l-3.208 3.11H18.74a.7.7 0 0 1 0 1.4H7.028l3.209 3.112a.7.7 0 0 1-.975 1.005L4.926 8.278a.7.7 0 0 1-.296-.32",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTransferi);
export default ForwardRef;